import { JsonObject } from 'json2typescript';
import { AccountStatementDocumentsResultInterface } from '../interfaces/accountstatementdocuments.interface';

@JsonObject('AccountStatementDocumentsResultModel')
export class AccountStatementDocumentsResultModel
  implements AccountStatementDocumentsResultInterface
{
  Alias?: string;
  PortfolioCode?: string;
  AccountStatementDocuments?: AccountStatementDocumentResultModel[];

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}

@JsonObject('AccountStatementDocumentResultModel')
export class AccountStatementDocumentResultModel {
  CreateDate?: string;
  Date?: string;
  Description?: string;
  DocumentFilename?: string;
  DocumentId?: string;
  DocumentName?: string;
  DocumentType?: string;
  Name?: string;
  UploadDate?: string;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}
